module.exports = __webpack_public_path__ + "img/130.d7dacb14.jpg";